// form
export const FROM = 'from'
export const TO = 'to'

// Interventions
export const ACTIVITY_DATE = 'activityDate'
export const COMPLETION_DATE = 'completionDate'
export const CREATION_DATE = 'creationDate'
export const FIRST_NAME = 'firstName'
export const GOAL = 'goal'
export const GOAL_UUID = 'goalUuid'
export const INTERVENTION = 'intervention'
export const INTERVENTION_UUID = 'interventionUuid'
export const LAST_NAME = 'lastName'
export const PATIENT = 'patient'
export const PATIENT_FIRST_NAME = 'patientFirstName'
export const PATIENT_LAST_NAME = 'patientLastName'
export const PATIENT_STATUS = 'patient.status' // just for consistency with QM Dashboard
export const PREVENTIVE_TYPE = 'preventiveType'
export const REFERRAL_PAYER = 'referralPayer'
export const REFERRAL_PAYER_UUID = 'referralPayerUuid'
export const REFERRAL_SOURCE = 'referralSource'
export const STATUS = 'status'
export const UUID = 'uuid'
export const YEAR = 'year'

// Patient address
export const PATIENT_ADDRESS_ADDRESS_PROP = 'address'
export const PATIENT_ADDRESS_CITY_PROP = 'city'
export const PATIENT_ADDRESS_STATE_PROP = 'state'
export const PATIENT_ADDRESS_ZIP_PROP = 'zip'
export const PATIENT_ADDRESS_TYPE_PROP = 'type'
export const PATIENT_ADDRESS_PRIMARY_PROP = 'isPrimary'

// Patient phone numbers
export const PATIENT_PHONE_NUMBER_PROP = 'number'
export const PATIENT_PHONE_TYPE_PROP = 'type'
export const PATIENT_PHONE_DESCRIPTION_PROP = 'description'

// Patient emails
export const PATIENT_EMAIL_EMAIL_PROP = 'email'
export const PATIENT_EMAIL_TYPE_PROP = 'type'
export const PATIENT_EMAIL_DESCRIPTION_PROP = 'description'

// Patient emergency contacts
export const PATIENT_EMERGENCYCONTACT_NAME_PROP = 'name'
export const PATIENT_EMERGENCYCONTACT_RELATIONSHIP_PROP = 'relationship'
export const PATIENT_EMERGENCYCONTACT_PHONE_PROP = 'phoneNumber'
export const PATIENT_EMERGENCYCONTACT_ADDRESS_PROP = 'address'
export const PATIENT_EMERGENCYCONTACT_EMAIL_PROP = 'email'
export const PATIENT_EMERGENCYCONTACT_NOTE_PROP = 'note'

// Referral address
export const REFERRAL_ADDRESS_ADDRESS_PROP = 'address'
export const REFERRAL_ADDRESS_CITY_PROP = 'city'
export const REFERRAL_ADDRESS_STATE_PROP = 'state'
export const REFERRAL_ADDRESS_ZIP_PROP = 'zip'
export const REFERRAL_ADDRESS_TYPE_PROP = 'type'

// Referral phone
export const REFERRAL_PHONE_NUMBER_PROP = 'number'
export const REFERRAL_PHONE_TYPE_PROP = 'type'
export const REFERRAL_PHONE_DESCRIPTION_PROP = 'description'

// Referral emergency contact
export const REFERRAL_EMERGENCYCONTACT_NAME_PROP = 'name'
export const REFERRAL_EMERGENCYCONTACT_RELATIONSHIP_PROP = 'relationship'
export const REFERRAL_EMERGENCYCONTACT_PHONE_PROP = 'phoneNumber'
export const REFERRAL_EMERGENCYCONTACT_ADDRESS_PROP = 'address'
export const REFERRAL_EMERGENCYCONTACT_EMAIL_PROP = 'email'
export const REFERRAL_EMERGENCYCONTACT_NOTE_PROP = 'note'

// Referral insurances
export const REFERRAL_INSURANCE_POLICYNUMBER_PROP = 'policyNumber'
export const REFERRAL_INSURANCE_GROUPNUMBER_PROP = 'groupNumber'
export const REFERRAL_INSURANCE_PLANNAME_PROP = 'planName'
export const REFERRAL_INSURANCE_EFFECTIVEDATE_PROP = 'effectiveDate'
export const REFERRAL_INSURANCE_EXPIRATIONDATE_PROP = 'expirationDate'
export const REFERRAL_INSURANCE_INSURANCE_PROP = 'insurance'
export const REFERRAL_INSURANCE_ORDER_PROP = 'orderNumber'

// Patient problems/diseases
export const PATIENT_DISEASE_DISEASE_PROP = 'name'
export const PATIENT_DISEASE_DISEASE_ENTITY_PROP = 'disease'
export const PATIENT_DISEASE_PRIMARY_PROP = 'isPrimary'
export const PATIENT_DISEASE_STARTDATE_PROP = 'startDate'
export const PATIENT_DISEASE_ENDDATE_PROP = 'endDate'

// Patient diagnoses
export const PATIENT_DIAGNOSIS_DIAGNOSIS_PROP = 'icd10'
export const PATIENT_DIAGNOSIS_PROGNOSIS_PROP = 'prognosis'
export const PATIENT_DIAGNOSIS_STARTDATE_PROP = 'startDate'
export const PATIENT_DIAGNOSIS_ENDDATE_PROP = 'endDate'
export const PATIENT_DIAGNOSIS_PRIMARY_PROP = 'isPrimary'
export const PATIENT_DIAGNOSIS_SECONDARY_PROP = 'isSecondary'
export const PATIENT_DIAGNOSIS_PRIORITY_PROP = 'orderNumber'
